import React from 'react';
import type { SVGProps } from 'react';

interface TopicIconSvgProps extends SVGProps<SVGSVGElement> {}

export const MedicalIcon: React.FC<TopicIconSvgProps> = (props) => (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.1099 0.125C14.9809 0.125 17.3088 2.45229 17.3091 5.32324V5.44824H15.7163V5.32324C15.7161 3.33208 14.1011 1.71777 12.1099 1.71777C10.1189 1.71803 8.50464 3.33224 8.50439 5.32324V12.498H6.91162V5.32324C6.91187 2.45245 9.23906 0.125258 12.1099 0.125Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.25"
    />
    <path
      d="M12.1108 24.0952C9.23982 24.0952 6.91187 21.7679 6.91162 18.897V18.772H8.50439V18.897C8.50464 20.8881 10.1196 22.5024 12.1108 22.5024C14.1018 22.5022 15.7161 20.888 15.7163 18.897V11.7222H17.3091V18.897C17.3088 21.7678 14.9816 24.095 12.1108 24.0952Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.25"
    />
    <path
      d="M0.125 12.1104C0.125 9.23935 2.45229 6.91139 5.32324 6.91113L5.44824 6.91113L5.44824 8.50391L5.32324 8.50391C3.33208 8.50416 1.71777 10.1191 1.71777 12.1104C1.71802 14.1014 3.33223 15.7156 5.32324 15.7158L12.498 15.7158L12.498 17.3086L5.32324 17.3086C2.45244 17.3083 0.125246 14.9811 0.125 12.1104Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.25"
    />
    <path
      d="M24.0952 12.1099C24.0952 14.9809 21.7679 17.3088 18.897 17.3091L18.772 17.3091L18.772 15.7163L18.897 15.7163C20.8881 15.7161 22.5024 14.1011 22.5024 12.1099C22.5022 10.1189 20.888 8.50465 18.897 8.50439L11.7222 8.50439L11.7222 6.91162L18.897 6.91162C21.7678 6.91188 24.095 9.23907 24.0952 12.1099Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.25"
    />
  </svg>
);
